import React from 'react';

const LEAF_COLORS = ['🍂', '🍁', '🍃'];

const ThanksgivingDecorations = () => {
  // Generate falling leaves
  const leaves = Array.from({ length: 30 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 12,
    duration: 10 + Math.random() * 8,
    emoji: LEAF_COLORS[Math.floor(Math.random() * LEAF_COLORS.length)],
    size: 16 + Math.random() * 16,
    opacity: 0.5 + Math.random() * 0.3,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {/* Falling leaves */}
      {leaves.map((leaf) => (
        <div
          key={`leaf-${leaf.id}`}
          className="absolute animate-float-leaf"
          style={{
            left: `${leaf.left}%`,
            top: '-40px',
            fontSize: `${leaf.size}px`,
            opacity: leaf.opacity,
            animationDelay: `${leaf.delay}s`,
            animationDuration: `${leaf.duration}s`,
          }}
        >
          {leaf.emoji}
        </div>
      ))}

      {/* Warm autumn gradient overlay at edges */}
      <div className="absolute top-0 left-0 w-24 h-full bg-gradient-to-r from-amber-700/10 to-transparent" />
      <div className="absolute top-0 right-0 w-24 h-full bg-gradient-to-l from-orange-700/10 to-transparent" />
    </div>
  );
};

export default ThanksgivingDecorations;
